enum SizeUnit {
  Millimetre = 'Millimetre',
  Inch = 'Inch',
}

export default SizeUnit;
